import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import ru from 'vuetify/es5/locale/ru'


Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: { ru },
        current: 'ru',
    },

theme: {
    dark: true,

    themes: {
        light: {
            primary: '#2196F3', // #E53935
            secondary: '#333333', // #E53935
        },
        dark: {
            primary: '#2196F3', // #E53935
            secondary: '#ffffff', // #E53935
        },
    },
},

});
